import { AddProfile } from '../components/ui/AddProfile';
type AddProfileScreenProps = {
    screenName: string;
    screenKey: string;
};

export const AddProfileScreen: React.FC<AddProfileScreenProps> = ({ screenName, screenKey }) => {
    return (
        <>
            <AddProfile />
        </>
    );
};
